import { chakra } from '@chakra-ui/react'
import type { FC } from 'react'
import {
  StatGroup,
  Stat,
  StatLabel,
  StatNumber,
  Badge,
} from '@chakra-ui/react'
import {
  FaBacterium,
  FaTint,
  FaPercentage,
} from 'react-icons/fa'


import { PARASITEMIA_THRESHOLD } from '../../../utils/constants'
import { AnalysisMalariaReport } from '../../../models/analysis-malaria-report'
import { useTranslation } from 'react-i18next'

const ChakraFaBacterium = chakra(FaBacterium as FC)
const ChakraFaTint = chakra(FaTint as FC)
const ChakraFaPercentage = chakra(FaPercentage as FC)

const ReportStats = ({
  analysisMalariaReport,
}: {
  analysisMalariaReport: AnalysisMalariaReport
}) => {
  const { t } = useTranslation()

  return (
    <StatGroup flexWrap="wrap" gap={6} mb={6}>
      <Stat
        bg="brand.50"
        p={4}
        borderRadius="xl"
        borderLeft="5px solid"
        borderColor="red.400"
      >
        <StatLabel
          fontWeight="medium"
          color="gray.600"
          display="flex"
          alignItems="center"
          gap={2}
        >
         <ChakraFaBacterium color="red.500" boxSize={5} />
          {t('ai.malaria.report.totalInfectedRbc')}
        </StatLabel>
        <StatNumber fontSize="2xl">
          {analysisMalariaReport.infectedRbcCount}
        </StatNumber>
      </Stat>

      <Stat
        bg="brand.50"
        p={4}
        borderRadius="xl"
        borderLeft="5px solid"
        borderColor="green.400"
      >
        <StatLabel
          fontWeight="medium"
          color="gray.600"
          display="flex"
          alignItems="center"
          gap={2}
        >
          <ChakraFaTint color="green.500" boxSize={5} />
          {t('ai.malaria.report.totalUninfectedRbc')}
        </StatLabel>
        <StatNumber fontSize="2xl">
          {analysisMalariaReport.uninfectedRbcCount}
        </StatNumber>
      </Stat>

      <Stat
        bg="brand.50"
        p={4}
        borderRadius="xl"
        borderLeft="5px solid"
        borderColor="blue.400"
      >
        <StatLabel
          fontWeight="medium"
          color="gray.600"
          display="flex"
          alignItems="center"
          gap={2}
        >
          <ChakraFaPercentage color="blue.500" boxSize={5} />
          {t('ai.malaria.report.estimatedParasitemia')}
        </StatLabel>
        <StatNumber fontSize="2xl" display="flex" alignItems="center">
          {analysisMalariaReport.estimatedParasitemiaPercent.toFixed(2)}%
          <Badge
            ml={2}
            colorScheme={
              analysisMalariaReport.estimatedParasitemiaPercent >
              PARASITEMIA_THRESHOLD
                ? 'red'
                : 'green'
            }
          >
            {analysisMalariaReport.estimatedParasitemiaPercent >
            PARASITEMIA_THRESHOLD
              ? t('ai.malaria.report.high')
              : t('ai.malaria.report.low')}
          </Badge>
        </StatNumber>
      </Stat>
    </StatGroup>
  )
}

export default ReportStats
